import { render, staticRenderFns } from "./AppointmentTimeslotSelection.vue?vue&type=template&id=b4e31bbe"
import script from "./AppointmentTimeslotSelection.vue?vue&type=script&lang=ts"
export * from "./AppointmentTimeslotSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports